"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var antd_1 = require("antd");
var CloseSquare_1 = require("@styled-icons/evaicons-solid/CloseSquare");
var StyledRibbonInner = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n"], ["\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n"])));
function Points(props) {
  var _this = this;
  var usedPoints = props.usedPoints,
    privateProfile = props.privateProfile,
    onUsePoints = props.onUsePoints;
  var AppActions = (0, reconnect_js_1.useOutlet)('actions')[0];
  var handlePointsUse = function (use) {
    return __awaiter(_this, void 0, void 0, function () {
      var ex_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            AppActions.setLoading(true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, onUsePoints(use)];
          case 2:
            _a.sent();
            return [3 /*break*/, 4];
          case 3:
            ex_1 = _a.sent();
            if (ex_1 === null || ex_1 === void 0 ? void 0 : ex_1.response) {
              if (ex_1.response.error === 'permission_denied') {
                antd_1.message.error('憑證過期，請重新登入');
              }
            }
            return [3 /*break*/, 4];
          case 4:
            AppActions.setLoading(false);
            return [2 /*return*/];
        }
      });
    });
  };
  return react_1.default.createElement("div", null, react_1.default.createElement("div", {
    style: {
      display: 'flex',
      marginBottom: 10
    }
  }, react_1.default.createElement("p", {
    style: {
      marginRight: 10,
      letterSpacing: 0.5,
      fontWeight: 'bold'
    }
  }, react_1.default.createElement("span", null, "\u4F7F\u7528", react_1.default.createElement("span", {
    className: "point"
  }, react_1.default.createElement("label", null, "\u7D05\u5229")), "\u6298\u62B5(\u60A8\u7684", react_1.default.createElement("span", {
    className: "point"
  }, react_1.default.createElement("label", null, "\u7D05\u5229")), react_1.default.createElement("span", {
    style: {
      fontWeight: 'bold',
      color: '#d11d26',
      marginRight: 3,
      marginLeft: 3
    }
  }, privateProfile.points), "\u9EDE)")), react_1.default.createElement(antd_1.Switch, {
    checked: !!usedPoints,
    disabled: privateProfile.points === 0,
    onChange: function (checked) {
      return handlePointsUse(checked);
    }
  })), usedPoints && react_1.default.createElement(antd_1.Badge.Ribbon, {
    color: "red",
    text: react_1.default.createElement(StyledRibbonInner, {
      onClick: function () {
        return handlePointsUse(false);
      }
    }, react_1.default.createElement("span", null, react_1.default.createElement("span", {
      className: "point"
    }, react_1.default.createElement("label", null, "\u7D05\u5229")), "\u9EDE\u6578"), react_1.default.createElement(CloseSquare_1.CloseSquare, {
      size: 18
    }))
  }, react_1.default.createElement(antd_1.Card, {
    title: usedPoints.name,
    size: "small"
  }, react_1.default.createElement(PointsInfo, null, react_1.default.createElement("label", null, "\u6298\u62B5\u9EDE\u6578"), react_1.default.createElement("h4", null, usedPoints.points), react_1.default.createElement("label", null, "\u6298\u62B5\u91D1\u984D"), react_1.default.createElement("h4", null, usedPoints.amount)))));
}
exports.default = Points;
var PointsInfo = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  & label {\n    display: block;\n    color: #ccc;\n  }\n\n  & h4 {\n    color: black;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  & label {\n    display: block;\n    color: #ccc;\n  }\n\n  & h4 {\n    color: black;\n  }\n"])));
var templateObject_1, templateObject_2;